import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });

        if(parsedParameters.error){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Failed to resolve function parameters.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let resolvedParams = parsedParameters['accumulator'];
        if(resolvedParams['watchPositionId'] === undefined || resolvedParams['watchPositionId'] === null){
            console.log('clearWatchPositionParser ERROR - Watch Position ID is required');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Watch Position ID is required',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(navigator.geolocation){
            navigator.geolocation.clearWatch(resolvedParams['watchPositionId']);
        }

        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableObject
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/clearWatchPositionParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : []
        } 
    }
}